import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  ListItem,
} from '@mui/material';
import Checkbox from '@digital-hig/checkbox';
import { formatLabel } from '../../../utils/filter.util';

const FilterListItem = ({
  option,
  handleInputChange,
  filterKey,
  isSelected,
}) => {
  const { t } = useTranslation();
  const dataWatVal = [
    filterKey,
    option.group, // will be `undefined` or `null` if not present
    option.value,
  ].filter(Boolean).join('-');

  return (
    <ListItem onClick={() => handleInputChange(option, filterKey, isSelected)} data-wat-val={dataWatVal} data-wat-loc="filters">
      <Checkbox
        id={`checkbox-${option.value}`}
        size="medium"
        checked={isSelected}
      />
      {t(formatLabel(option.value))}
    </ListItem>
  );
};

FilterListItem.propTypes = {
  option: PropTypes.shape({ value: PropTypes.string, group: PropTypes.string }),
  filterKey: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

FilterListItem.defaultProps = {
  option: {},
  filterKey: '',
};
export default FilterListItem;
